import { connect } from 'react-redux';
import FreezeMembershipPage from 'pages/FreezeMembershipPageNew';
import newOlsActions from 'store/newOls/actions';
import membershipFormsActions from 'store/membershipForms/actions';

const mapStateToProps = state => {
  return {
    freezeDropdownDetails: state.membershipForms.freezeDropdownDetails,
    isSubmitFreezeLoading: state.membershipForms.isSubmitFreezeLoading,
    freezeFormDetails: state.membershipForms.freezeFormDetails,
  };
};
const mapDispatchToProps = {
  loadFreezeDropdownData: membershipFormsActions.Creators.loadFreezeDropdownDataRequest,
  submitFreezeForm: membershipFormsActions.Creators.submitFreezeRequest,
  resetFreezeFormDetails: membershipFormsActions.Creators.resetFreezeFormDetails,
};
export default connect(mapStateToProps, mapDispatchToProps)(FreezeMembershipPage);
